import { render, staticRenderFns } from "./pin-create-or-update.vue?vue&type=template&id=16fc73ac&scoped=true&"
import script from "./pin-create-or-update.component.ts?vue&type=script&lang=ts&"
export * from "./pin-create-or-update.component.ts?vue&type=script&lang=ts&"
import style0 from "./pin-create-or-update.vue?vue&type=style&index=0&id=16fc73ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fc73ac",
  null
  
)

export default component.exports